import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

interface IntelActivityBarChartProps {
    data?: { date: string; count: number }[];
    isLoading?: boolean;
}

const IntelActivityBarChart: React.FC<IntelActivityBarChartProps> = ({ data = [], isLoading }) => {
    if (isLoading) {
        return (
            <div className="w-full h-full flex items-center justify-center text-[#00FFFF] font-mono text-xs animate-pulse">
                Syncing timeline...
            </div>
        );
    }

    if (!data || data.length === 0) {
        return (
            <div className="w-full h-full flex items-center justify-center text-slate-600 font-mono text-xs border border-dashed border-[#1A1D24] rounded-lg">
                No activity telemetry available.
            </div>
        );
    }

    const CustomTooltip = ({ active, payload, label }: any) => {
        if (active && payload && payload.length) {
            return (
                <div className="bg-[#0A0B0E]/95 backdrop-blur-md border border-[#1A1D24] p-3 rounded-lg shadow-[0_0_15px_rgba(0,0,0,0.5)] font-mono z-50">
                    <p className="text-[10px] text-slate-500 uppercase tracking-widest mb-1">{label}</p>
                    <div className="flex items-end gap-2">
                        <span className="text-xl font-bold text-white leading-none">{payload[0].value.toLocaleString()}</span>
                        <span className="text-[10px] text-[#00FFFF] uppercase tracking-wide">Events</span>
                    </div>
                </div>
            );
        }
        return null;
    };

    return (
        <div className="absolute inset-0">
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    data={data}
                    margin={{ top: 20, right: 0, left: -20, bottom: 0 }}
                >
                    <CartesianGrid vertical={false} strokeDasharray="3 3" stroke="#1A1D24" />
                    <XAxis
                        dataKey="date"
                        axisLine={false}
                        tickLine={false}
                        tick={{ fill: '#475569', fontSize: 10, fontFamily: 'monospace' }}
                        dy={10}
                    />
                    <YAxis
                        axisLine={false}
                        tickLine={false}
                        tick={{ fill: '#475569', fontSize: 10, fontFamily: 'monospace' }}
                        dx={-10}
                    />
                    <Tooltip content={<CustomTooltip />} cursor={{ fill: '#1A1D24', opacity: 0.4 }} />
                    <Bar dataKey="count" radius={[2, 2, 0, 0]}>
                        {data.map((index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill="#00FFFF"
                                style={{ filter: 'drop-shadow(0px 0px 4px rgba(0, 255, 255, 0.5))' }}
                            />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default IntelActivityBarChart;